// src/services/permission.service.ts
import { ListApiResponse } from "@/types/common";
import { privateRequest } from "../axios";
import { SinglePermission } from "@/types/permission";
import toast from "@/lib/toast";

export interface Permission {
  _id: number;
  name: string;
  actionName?: string;
  method?: "GET" | "POST" | "PUT" | "DELETE";
  baseUrl?: string;
  path?: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

// export interface PermissionsResponse {
//   rows: Permission[];
//   count: number;
// }

// export interface ApiResponse<T> {
//   statusCode: number;
//   success: boolean;
//   message: string;
//   data: T;
// }
const ENDPOINTS = {
  PERMISSION: "/permission",
  PERMISSION_EXPORT: "/permission/export",
  ALL_PERMISSION: "/permission/all",
  PERMISSION_ID: (id: number | string) => `/permission/${id}`,
};

// ✅ Get Permissions (with optional query params)
const getPermissions = async (params?: Record<string, any>) => {
  const response = await privateRequest.get<ListApiResponse<SinglePermission>>(
    ENDPOINTS.PERMISSION,
    { params }
  );
  return response.data.data; // ⬅️ always inside `data`
};

const getAllPermissions = async (params?: Record<string, any>) => {
  const response = await privateRequest.get<
    ListApiResponse<
      Omit<
        SinglePermission,
        "method" | "baseUrl" | "path" | "__v" | "createdAt" | "updatedAt"
      >
    >
  >(ENDPOINTS.ALL_PERMISSION, { params });
  return response.data; // ⬅️ always inside `data`
};

// ✅ Get Permission by ID
const getPermissionById = async (id: number | string) => {
  const response = await privateRequest.get<Permission>(
    ENDPOINTS.PERMISSION_ID(id)
  );
  return response.data.data;
};

// ✅ Add Permission
const addPermission = async (
  data: Omit<Permission, "id">
): Promise<Permission> => {
  const response = await privateRequest.post<Permission>(
    ENDPOINTS.PERMISSION,
    data
  );
  return response.data;
};

// ✅ Update Permission
const updatePermission = async (
  id: number | string,
  data: Partial<Permission>
): Promise<Permission> => {
  const response = await privateRequest.put<Permission>(
    ENDPOINTS.PERMISSION_ID(id),
    data
  );
  return response.data;
};

// ✅ Delete Permission
const deletePermission = async (
  id: number | string
): Promise<{ success: boolean; message?: string }> => {
  const response = await privateRequest.delete<{
    success: boolean;
    message?: string;
  }>(ENDPOINTS.PERMISSION_ID(id));
  return response.data;
};

const exportPermissionData = async (params: any) => {
  const response = await privateRequest.post(
    ENDPOINTS.PERMISSION_EXPORT,
    null,
    {
      params,
    }
  );

  if (response?.data?.success) {
    toast.success(response?.data?.data);
  }
  return response?.data;
};

const PermissionService = {
  getPermissions,
  getPermissionById,
  addPermission,
  updatePermission,
  deletePermission,
  getAllPermissions,
  exportPermissionData,
};

export default PermissionService;
